import { render } from "./SurveyNumbers.vue?vue&type=template&id=7fb6d729&scoped=true"
import script from "./SurveyNumbers.vue?vue&type=script&lang=js"
export * from "./SurveyNumbers.vue?vue&type=script&lang=js"

import "./SurveyNumbers.vue?vue&type=style&index=0&id=7fb6d729&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb6d729"]])

export default __exports__